export class BaseController {
  id = 'BaseController';

  init() {}

  getId() {
    return this.id;
  }

  _setRootElement(elem) {
    this._rootElement = elem;
  }

  _getRootElement() {
    return this._rootElement;
  }

  _getChildNodeElement(name) {
    const elems = this._rootElement.querySelectorAll('[data-element]');
    const matchingElems = [];

    elems.forEach((elem) => {
      if (elem.dataset.element === name) {
        matchingElems.push(elem);
      }
    });

    return matchingElems;
  }

  singleChildNode(name) {
    return this._getChildNodeElement(name)[0];
  }

  childNodes(name) {
    return this._getChildNodeElement(name);
  }

  getRoot() {
    return this._getRootElement();
  }

  _getDataFromNode(node, dataName) {
    return node.dataset[dataName];
  }

  _setDataOnNode(node, dataName, value) {
    const el = node;
    el.dataset[dataName] = value;
  }

  getData(node, name) {
    return this._getDataFromNode(node, name);
  }

  setData(node, name, value) {
    this._setDataOnNode(node, name, value);
  }

  _setOnOffClass(node, className, onOff) {
    const el = node;

    if (onOff === 'on') {
      el.classList.add(className);
    } else {
      el.classList.remove(className);
    }
  }

  _toggleClass(node, className) {
    const el = node;
    el.classList.toggle(className);
  }

  toggleClass(node, className, onOff = null) {
    if (onOff) {
      this._setOnOffClass(node, className, onOff);
    } else {
      this._toggleClass(node, className);
    }
  }
}

export function load(controllers) {
  const setControllers = [];
  const allControllers = document.querySelectorAll('[data-controller]');
  if (allControllers.length > 0) {
    allControllers.forEach((controller) => {
      controllers.forEach((C) => {
        const cls = new C();
        if (controller.dataset.controller === cls.getId()) {
          console.info('Initiating controller', cls.getId()); // eslint-disable-line no-console
          cls._setRootElement(controller);
          cls.init();
          const singleObj = {
            elem: controller,
            classType: cls,
          };
          setControllers.push(singleObj);
        }
      });
    });
  }
}
